import { CaseStudy } from '@types';

// NOTE: currently we don't generate for rapid projects, as we don't have content created.
export const shouldIncludeCaseStudy = (caseStudy: CaseStudy) => !caseStudy.site.includes('rapid');
